import { ValidateResult } from 'react-hook-form';
import { FormError } from 'shared/components/FormControl';

import { AccountModule } from 'dashboard/models/account-type-grid-layouts';
import { Tab } from 'dashboard/models/grid-layout';
import Button from 'design-system/components/Button';
import Input from 'design-system/components/Input';
import Spacer from 'design-system/components/Spacer';
import { HStack } from 'design-system/components/Stack';
import { Label } from 'design-system/components/Text';
import { useFormSecurely } from 'lib/security/reactHookForm';

interface FormEditAccountLayoutTabProps {
  cancel: () => void;
  submit: (tab: Tab<AccountModule>) => void;
  tab: Tab<AccountModule>;
  validateTabName: (tabName: string, tabToken?: string) => ValidateResult;
}

export const FormEditAccountLayoutTab = ({
  cancel,
  submit,
  tab,
  validateTabName,
}: FormEditAccountLayoutTabProps) => {
  const {
    register: wrappedRegister,
    handleSubmit,
    formState: { isValid, errors },
  } = useFormSecurely({ defaultValues: { tabName: tab.name }, mode: 'onChange' });

  return (
    <form
      onSubmit={handleSubmit(({ tabName }) => {
        // massage the return value of the form to be the full updated tab object
        submit({
          ...tab,
          name: tabName,
        });
      })}
    >
      <Label size='md' htmlFor='tabName' weight='bold'>
        Tab name
      </Label>
      <Input
        {...wrappedRegister('tabName', {
          validate: (tabName) => validateTabName(tabName, tab.token),
        })}
        id='tabName'
        title='Edit Tab Name'
        type='text'
        placeholder='e.g. Summary'
      />
      {errors.tabName && <FormError role='alert'>{errors.tabName.message}</FormError>}
      <Spacer height={3} />
      <HStack equal>
        <Button
          variant='basic'
          id='confirmation-modal__cancel'
          data-test='confirmation-modal__cancel'
          autoFocus={true}
          onClick={cancel}
        >
          Cancel
        </Button>
        <Button
          type='submit'
          variant='primary'
          id='confirmation-modal__confirm'
          data-test='confirmation-modal__confirm'
          disabled={!isValid}
        >
          Confirm
        </Button>
      </HStack>
    </form>
  );
};
